import { Stack } from '@ltvco/refresh-lib/theme';

import { IdMonitorContainer } from '../../../../components/idMonitor/IdMonitorContainer';
import { OneTimePasscodeProvider } from '../../../../components/idMonitor/Oxford/OneTimePasscodeContext';
import { SettingsTiles } from '../../../../components/idMonitor/SettingsTiles/SettingsTiles';

export const IdentityMonitorTab = () => {
  return (
    <>
      <Stack gap={2.5}>{<SettingsTiles />}</Stack>
      <OneTimePasscodeProvider>
        <IdMonitorContainer />
      </OneTimePasscodeProvider>
    </>
  );
};
